<template>
  <!-- nTOP, nBottom 的nav -->

  <!-- 最底层背景 -->
  <div :class="['nav-wrap', navData.className]" :style="css.navWrap">
    <!-- 导航栏背景 -->
    <div
      class="nav-ctn"
      :class="[actived.far, actived.son, fixNavTop && 'fixed']"
      :style="[css.navCtn, fixNavTop ? css.navCtnFixed : '']"
      ref="navBtnCon"
    >
      <div class="nav-ctn-inside" ref="navBtnInside" :style="[css.navCtnInside || '']">
        <!-- 一级标题 -->
        <div
          :class="['nav-ctn-top']"
          :style="[css.topBtnLayout, fixNavTop ? css.topBtnLayoutFixed : '']"
        >
          <template v-for="(item, index) in topNavs">
            <!--一级标题图-->
            <img
              :class="[
                'nav-btn',
                actived.far === item.key ? 'actived' : '',
                top2SpecCss,
                guofengSpec2
              ]"
              v-show="item.show && actived.far === item.key"
              :key="'c' + index"
              :style="[css.topBtnBaseCss, item.style]"
              :src="item.img_actived"
              @click="handleNavFarClick(item.key)"
            />
            <img
              class="nav-btn"
              v-show="item.show && actived.far !== item.key"
              :src="item.img"
              :key="index"
              :style="[css.topBtnBaseCss, css.topBtnBaseCss2, item.style]"
              @click="handleNavFarClick(item.key)"
            />
            <!--一级分隔符-->
            <div
              v-show="index < topNavs.length - 1 && navData.showLine1"
              class="flex"
              :key="'l' + index"
            >
              <div :style="css.LineCss1"></div>
            </div>
          </template>
        </div>
        <!-- 二级标题 -->
        <div
          :class="['nav-ctn-bottom', buding1, bottomNavflexStart, withYouSpec]"
          :style="css.bottomBtnLayout"
        >
          <template v-for="(item, index) in subNavs">
            <!--二级标题图-->
            <img
              :class="['nav-btn', guofengSpec]"
              v-show="item.show && actived.son === item.key"
              :src="item.img_actived"
              :key="'c' + index"
              :style="[css.bottomBtnBaseCss, buding2, item.style]"
              @click="handleNavSonClick(item.key)"
            />
            <img
              class="nav-btn"
              v-show="item.show && actived.son !== item.key"
              :src="item.img"
              :key="index"
              :style="[css.bottomBtnBaseCss, css.bottomBtnBaseCss2, buding2, item.style]"
              @click="handleNavSonClick(item.key)"
            />
            <!--二级分隔符-->
            <div
              v-show="index < subNavs.length - 1 && navData.showLine2 && !item.hideLine"
              class="flex"
              :key="'l' + index"
            >
              <div :style="css.LineCss2"></div>
            </div>
          </template>
        </div>
        <!-- 三级标题 -->
        <div :class="['nav-ctn-third']" :style="css.thirdBtnLayout">
          <template v-for="(item, index) in thirdNavs">
            <!--三级标题图-->
            <img
              class="nav-btn"
              v-show="item.show && actived.third === item.key"
              :src="item.img_actived"
              :key="'c' + index"
              :style="[css.thirdBtnBaseCss, item.style]"
              @click="handleNavThirdClick(item.key)"
            />
            <img
              class="nav-btn"
              v-show="item.show && actived.third !== item.key"
              :src="item.img"
              :key="index"
              :style="[css.thirdBtnBaseCss, item.style]"
              @click="handleNavThirdClick(item.key)"
            />
            <!--三级分隔符-->
            <div
              v-if="index < thirdNavs.length - 1 && navData.showLine3"
              class="flex"
              :key="'l' + index"
            >
              <div :style="css.LineCss3"></div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../../utils/config/index";
export default {
  name: "nTopNBottom",

  props: {
    css: Object, // 注入css
    navData: Object, // 注入配置
    actived: Object,
    fixNavTop: Boolean // 定位控件
  },

  computed: {
    // 一级标题列表
    topNavs() {
      return this.navData.top;
    },
    // 二级标题列表
    subNavs() {
      if (!this.navData.bottom) return [];
      return this.navData.bottom[this.actived.far];
    },
    // 三级标题列表
    thirdNavs() {
      if (!this.navData.third) return [];
      return this.navData.third[this.actived.far + this.actived.son];
    },
    buding1() {
      // 大师肖像照补丁-2021-05-28
      return this.navData.specCss && this.actived.far === "top2" && "center";
    },
    buding2() {
      // 大师肖像照补丁-2021-05-28
      return this.navData.specCss && this.actived.far === "top2" && this.css.bottomBtnBaseCss2;
    },
    bottomNavflexStart() {
      return (
        this.navData.leftBottomNav &&
        this.actived.far === this.navData.leftBottomNavNum &&
        "flex-start"
      );
    },
    top2SpecCss() {
      return this.navData.retroSpec && this.actived.far === "top2" && "top2SpecCss";
    },
    guofengSpec() {
      return (
        this.navData.guofengSpec &&
        (this.actived.far === "top2" || this.actived.far === "top3") &&
        "guofengSpec"
      );
    },
    guofengSpec2() {
      return this.navData.guofengSpec && this.actived.far === "top1" && "guofengSpec2";
    },
    withYouSpec() {
      return this.navData.withYouSpec && this.actived.far === "top2" && "withYouSpec";
    }
  },

  created() {
    // 处理 the girl 2022 导航栏背景动态切换需求
    const { name } = this.$route.params;
    config[name].onChangeFun && config[name].onChangeFun(this);
  },

  watch: {
    actived(val) {
      if (!val) return false;

      const { navCtn } = this.css;
      const navRef = this.$refs?.navBtnInside;

      if (navCtn?.fun) {
        this[(navCtn?.fun)] && this[(navCtn?.fun)](val, navRef);
      }
    },

    deep: true,
    immediate: true
  },

  methods: {
    // click 一级标题
    handleNavFarClick(name) {
      this.$emit("farClick", { name });
    },
    // click 二级标题
    handleNavSonClick(name) {
      this.$emit("sonClick", { name });
    },
    // click 三级标题
    handleNavThirdClick(name) {
      this.$emit("thirdClick", { name });
    }
  }
};
</script>

<style scoped lang="less">
@import "./dlc.less";

.nav-wrap {
  margin-top: -2px;
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .nav-ctn {
    position: relative;
    z-index: 3;
    width: 100%;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;

    &.fixed {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
    }
  }

  .nav-ctn-top {
    display: flex;
    justify-content: space-between;

    .nav-btn {
      display: inline-block;
      // width: 105px;
      // height: 25px;
      background-repeat: no-repeat;
      background-size: contain;
    }
  }

  .nav-ctn-bottom,
  .nav-ctn-third {
    display: flex;
    justify-content: space-between;

    &.flex-start {
      justify-content: flex-start;

      .nav-btn {
        margin-right: 30px;
      }
    }

    &.center {
      justify-content: center !important;
    }

    .nav-btn {
      display: inline-block;
      // width: 50px;
      // height: 25px;
      background-repeat: no-repeat;
      background-size: contain;
    }
  }

  .nav-ctn-top,
  .nav-ctn-bottom,
  .nav-ctn-third {
    .flex {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
